import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faCode,
  faEnvelope,
  faHome,
  faLaptopCode,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <div
      className="d-flex flex-column vh-100 bg-dark p-3 border-right"
      style={{ width: "100px" }}
    >
      <div className="mb-4">
        <img
          src="/images/zaheer_profile_squre.jpg"
          alt="Logo"
          className="img-fluid"
          style={{ width: "50px", height: "50px", borderRadius: "50%" }}
        />
      </div>

      <ul className="nav flex-column">
        <li className="nav-item">
          <Link to="/" className="nav-link text-white">
            <FontAwesomeIcon icon={faHome} title="Home" />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/about" className="nav-link text-white">
            <FontAwesomeIcon icon={faUser} title="About" />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/projects" className="nav-link text-white">
            <FontAwesomeIcon icon={faLaptopCode} title="Projects" />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/experience" className="nav-link text-white">
            <FontAwesomeIcon icon={faBriefcase} title="Experience" />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/skills" className="nav-link text-white">
            <FontAwesomeIcon icon={faCode} title="Skills" />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/contact" className="nav-link text-white">
            <FontAwesomeIcon icon={faEnvelope} title="Contact" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
